import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/video"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const Update = async (values) => {
    return await axiosInstance(options).put(`${path}/update`, values);
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details?id=${id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).put(`${path}/change-status`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values);
}
